<div class="inner-mat-dialog title-section flex justify-between content-stretch items-stretch flex-col">
  <!-- Title Section -->
  <div mat-dialog-title id="drug-details-header">
    <div class="flex justify-start content-center items-center flex-row">
      <div class="flex flex-row justify-start content-stretch items-stretch h-full basis-1/2">
        <h5>DRUG CLASSIFICATION RESOLUTION</h5>
      </div>
      <div class="flex flex-row justify-end content-stretch items-stretch h-full basis-1/2">
        <mat-icon (click)="this.dialogRef.close()" class="cross-wizard">
          <img src="/assets/img/icons/ico.16.clear.svg" alt="">
        </mat-icon>
      </div>
    </div>
  </div>

  <!-- Case Info Section-->
  <div class="case-info">
    <div class="info-item"><strong>Case Number : </strong>{{caseNumber}}</div>
    <div class="info-item"><strong>Priority : </strong>{{priority}}</div>
    <div class="info-item"><strong>Case Owner : </strong>{{owner}}</div>
    <div class="info-item"><strong>Account Name : </strong>{{account}}</div>
    <div class="info-item"><strong>Status : </strong>{{sfStatus}}</div>
    <div class="info-item"><strong>Case Source : </strong>{{source}}</div>
    <div class="info-item"><strong>Contact Name : </strong></div>
    <div class="info-item"><strong>Sub-Status : </strong></div>
    <div class="info-item"><strong>Days Aging : </strong>{{age}}</div>
  </div>

  <div>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="ndc">
        <th mat-header-cell *matHeaderCellDef> NDC </th>
        <td mat-cell *matCellDef="let drug"> {{drug.ndc}} </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Drug Name </th>
        <td mat-cell *matCellDef="let drug"> {{drug.drugName}} </td>
      </ng-container>

      <ng-container matColumnDef="strength">
        <th mat-header-cell *matHeaderCellDef> Strength </th>
        <td mat-cell *matCellDef="let drug"> {{drug.strength}} </td>
      </ng-container>

      <ng-container matColumnDef="manufacturer">
        <th mat-header-cell *matHeaderCellDef> Manufacturer </th>
        <td mat-cell *matCellDef="let drug"> {{drug.manufacturer}} </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let drug"> {{drug.active}} </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Source </th>
        <td mat-cell *matCellDef="let drug"> {{drug.source}} </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let drug">
          <button class="small-light-button" (click)="redirectToDetailsPage(drug.ndc,drug.sourceId)" *ngIf="drug.order !== 1">Classify</button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['ndc', 'name', 'strength', 'manufacturer', 'status', 'action']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['ndc', 'name', 'strength', 'manufacturer', 'status', 'action'];"
        [ngClass]="{'highlight': row.order === 1}"></tr>
    </table>
  </div>
  <div class="centered-container">
    <p>Drug doesn't exist? <button class="small-light-button" (click)="openImportWizardNewDrug()">Add New Drug</button></p>
  </div>

</div>
